const productsObjSelector = (state) => state.products?.all?.obj;

const allProductsSelector = (state) => state.products?.all;

const forOrderSelector = (state) => state.cart.forOrder || [];

const forOrderCachedSelector = (state) => state.cart.forOrderCached || [];

const kitsSelector = (state) => state.kits;

const sharedKitsSelector = (state) => state.sharedKits;

const sharedKitReorderMessageSelector = (state) =>
  state.sharedKits?.messages?.reorderMessage || '';

export {
  productsObjSelector,
  allProductsSelector,
  kitsSelector,
  sharedKitsSelector,
  sharedKitReorderMessageSelector,
  forOrderSelector,
  forOrderCachedSelector,
};
